module.exports = __webpack_public_path__ + "static/img/6.b46422b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carrusel/6.png
// module id = dHwZ
// module chunks = 5